export const fetchCurrencies = () => (
  (dispatch, getState, api) => api({
    apiPath: 'static/currencies'
  })
)

export const fetchTimezones = () => (
  (dispatch, getState, api) => api({
    apiPath: 'static/timezones'
  })
)

export const fetchPlans = () => (
  (dispatch, getState, api) => api({
    apiPath: 'static/plans'
  })
)
